import { createSelector } from 'reselect';

export default createSelector(
  state => state.elements.ChannelsPanel.messageId,
  messageId => messageId,
);
